<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="epi"> </p>
<p class="EP"><span epub:type="pagebreak" id="pg_vii" title="vii">We are not human beings having a spiritual journey. We are spiritual beings having a human journey.</span></p>
<p class="EPA">—Pierre Teilhard de Chardin (1881–1955)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?982c6d1e